import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Do I need a printer?',
  a: "Yes, the activity bundle is designed to be printed so you don't have to rely on screens or worry about charging devices."
}, {
  q: 'Is this just for planes?',
  a: 'No, the system works perfectly for road trips, trains, and even long wait times at restaurants.'
}, {
  q: 'My kid has a very short attention span. Will this work?',
  a: "That's exactly why the '20/20 Rotation' exists—it's designed specifically for short attention spans to keep novelty high."
}, {
  q: 'What if my child is already mid-meltdown?',
  a: "Turn straight to the R.E.S.E.T. Protocol in Chapter 3 for immediate 'first-responder' steps to de-escalate the situation."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-16 bg-white" data-id="element-28">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="text-center mb-8" data-id="element-30">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark" data-id="element-31">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3" data-id="element-32">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border border-gray-200 rounded-2xl overflow-hidden bg-brand-cream/30" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-34">
                <span className="font-bold text-base text-brand-dark" data-id="element-35">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-blue transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>
              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <div className="px-5 pb-5 text-gray-600 leading-relaxed text-sm" data-id="element-39">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}